import { useEffect } from 'react'
import { supabase } from '@/lib/supabase/client'
import { useChatStore } from '../store/chat-store'
import { useAuthStore } from '@/features/auth/store/auth-store'

/**
 * Hook leve para carregar apenas o contador de mensagens não lidas do chat global
 * Usado na Dashboard e outras páginas que não precisam carregar todas as mensagens
 */
export const useChatUnreadCount = () => {
  const { user } = useAuthStore()
  const { setUnreadCount } = useChatStore()

  useEffect(() => {
    if (!user) return

    /**
     * Carrega contador de não lidas
     */
    const loadUnreadCount = async () => {
      try {
        const { data, error } = await supabase
          .rpc('get_chat_unread_count')

        if (error) throw error

        setUnreadCount(data || 0)
      } catch (error) {
        console.error('Erro ao carregar contador de chat:', error)
      }
    }

    // Carrega inicial
    loadUnreadCount()

    // Configura real-time para atualizar quando houver novas mensagens
    const channel = supabase
      .channel('chat_unread_count_channel')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'chat_messages',
        },
        () => {
          loadUnreadCount()
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'chat_read_status',
          filter: `user_id=eq.${user.id}`,
        },
        () => {
          loadUnreadCount()
        }
      )
      .subscribe()

    return () => {
      channel.unsubscribe()
    }
  }, [user, setUnreadCount])
}

